

<template>
  <div>
    <Pane />

    <a-card class="container">
      <a-row>
        <a-col :span="22">
          <a-form-model
            :colon="false"
            :model="form"
            layout="inline"
            @keyup.enter.native="query"
          >
            <a-form-model-item>
              <a-input
                v-model="form.title"
                placeholder="名称"
                style="width: 150px"
              ></a-input>
            </a-form-model-item>
            <a-form-model-item>
              <a-select
                v-model="form.category"
                style="width: 150px"
                placeholder="分类"
              >
                <a-select-option
                  v-for="item in categoryList"
                  :key="item"
                  :value="item"
                >
                  {{ item }}
                </a-select-option>
              </a-select>
            </a-form-model-item>

            <a-form-model-item>
              <a-space>
                <a-button @click="query" type="primary">查询</a-button>
                <a-button @click="reset">重置</a-button>
              </a-space>
            </a-form-model-item>
          </a-form-model>
        </a-col>
        <a-col :span="2">
          <div class="right" style="margin-top: 4px">
            <a-button @click="$router.push($route.path + '/add')" type="primary"
              >发布案例</a-button
            >
          </div>
        </a-col>
      </a-row>

      <Padding />

      <a-table
        bordered
        :data-source="list"
        :loading="loading"
        @change="onChange"
        :pagination="{
          total,
          current,
          pageSize,
          showTotal: (total) => `共 ${total} 条记录`,
        }"
      >
        <a-table-column title="标题" data-index="title"> </a-table-column>
        <a-table-column title="分类" data-index="category"> </a-table-column>
        <a-table-column title="简介" data-index="content"> </a-table-column>
        <a-table-column title="规模" data-index="scale"> </a-table-column>
        <a-table-column title="地点" data-index="address"> </a-table-column>
        <a-table-column title="获奖情况" data-index="award"> </a-table-column>
        <a-table-column title="状态">
          <template slot-scope="text">
            <a-badge
              color="#f50"
              text="未审核"
              v-if="text.reviewStatus === 'notReady'"
            />
            <a-badge
              color="#1890ff"
              text="已审核"
              v-if="text.reviewStatus === 'approved'"
            />
          </template>
        </a-table-column>

        <a-table-column title="操作" align="right" width="140px">
          <template slot-scope="text">
            <a-space>
              <a
                href="#"
                class="danger"
                v-if="
                  $getPermission($route.path + '/review') &&
                  text.reviewStatus === 'notReady'
                "
                @click.prevent="approveText(text)"
                >审核通过</a
              >

              <a
                href="#"
                class="danger"
                v-if="text.reviewStatus === 'approved'"
                @click.prevent="preview(text)"
                >预览</a
              >

              <a
                href="#"
                @click="$router.push($route.path + '/edit?id=' + text.id)"
                >编辑</a
              >
              <a href="#" class="danger" @click.prevent="deleteText(text)"
                >删除</a
              >
            </a-space>
          </template>
        </a-table-column>
      </a-table>
    </a-card>
  </div>
</template>


<script>
import watermark from "@/mixins/watermark";
import { fetchList, remove, approve } from "@/api/website/case";
import { categoryList } from "./data";

export default {
  mixins: [watermark],

  data() {
    return {
      form: {},
      categoryList,

      loading: false,
      current: 1,
      pageSize: 10,
      list: [],
      total: 0,
    };
  },

  mounted() {
    this.getList();
  },

  methods: {
    getList() {
      const { current, pageSize, form } = this;
      this.loading = true;
      fetchList({
        pageNum: current,
        pageSize: pageSize,
        ...form,
      })
        .then((res) => {
          if (Array.isArray(res.list)) {
            this.list = Object.freeze(res.list);
            this.total = res.totalSize;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    onChange(pagination) {
      this.current = pagination.current;
      this.pageSize = pagination.pageSize;
      this.getList();
    },

    query() {
      this.current = 1;
      this.getList();
    },
    reset() {
      this.form = {};
      this.current = 1;
      this.getList();
    },

    preview(text) {
      window.open("https://www.njszy.com/business/detail?id=" + text.id);
    },

    approveText(text) {
      const that = this;
      this.$confirm({
        title: "确认要通过这条案例吗？",
        onOk() {
          approve({
            id: text.id,
          }).then(() => {
            that.getList();
          });
        },
      });
    },

    deleteText(text) {
      const that = this;
      this.$confirm({
        title: "确认要删除这条案例吗？",
        onOk() {
          remove({
            id: text.id,
          }).then(() => {
            that.getList();
          });
        },
      });
    },
  },
};
</script>